import React from 'react';
import PropTypes from 'prop-types'
import { FaEye, FaLink, FaStar,FaInfo, FaUtensils} from 'react-icons/fa';

function RepoItem({ repo }) {

  
     const {
 
         name,
         description,
         html_url,
         forks,
         open_issues,
         watchers_count,
         stargazers_count,

     } = repo


  return <div className="mb-2 rounded-md  shadow-sm shadow-white card-bg-00 hover:bg-slate-700 hover:text-white">

    <div className="card-body">
 
    <h3 className="mb-1 text-xl font-semibold">
 
     <a className='font-bold' href={html_url}>
 
     <FaLink className="inline  mr-1" />{name}

     </a>

    </h3>

       <p className="mb-3">{description}</p>
       <div className='flex -ml-8 lg:-ml-0'>

         <div className="mr-2 badge-info flex items-center badge-lg">
 
          <FaEye className='mr-2' />{watchers_count}
          
          </div>
         
          <div className="mr-2 badge-success flex items-center badge-lg ">
 
          <FaStar  className='mr-2 ' />{stargazers_count}
          
          </div>

           <div className="mr-2 badge-error flex items-center  badge-lg ">
 
          <FaInfo className='mr-2' />{open_issues}
          
          </div>

           <div className="mr-2 badge-warning flex items-center badge-2xl ">
 
          <FaUtensils className='mr-2 ' />{forks}
          
          </div>

       </div>

    </div>


  </div>;
}

RepoItem.protoTypes={

    repos: PropTypes.object.isRequired,
   
   }

export default RepoItem;
